// extracted by mini-css-extract-plugin
module.exports = {"image":"cu","image-placeholder":"cv","imagePlaceholder":"cv"};